// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/frame.css
// module id = qgwF
// module chunks = 88